// VENDITE_v1 — conti sulle fatture di vendita. Funzioni pure: non scrivono niente.
import { somiglia, lordoPag } from "./bancaAbbina";

const n2 = v => Math.round((Number(v) || 0) * 100) / 100;
const TOLL = 1; // sotto 1 euro sono arrotondamenti
const uguale = (a, b) => Math.abs(n2(a) - n2(b)) <= 0.011;
export const eNota = v => v.tipoFE === "TD04";
const ordine = (a, b) => String(a.data || "").localeCompare(String(b.data || "")) || (parseInt(a.numero, 10) || 0) - (parseInt(b.numero, 10) || 0);
export function giorniDa(data, oggi) {
  const a = Date.parse(data), b = Date.parse(oggi || new Date().toISOString().slice(0, 10));
  return isNaN(a) || isNaN(b) ? 0 : Math.round((b - a) / 86400000);
}
function contanti(p) { return /contant/i.test(String(p.metodo || "") + " " + String(p.tipo || "")); }
function incassiBanca(v) { return (v.incassi || []).reduce((s, x) => s + (Number(x.importo) || 0), 0); }

// Stato di ogni fattura e riepilogo per cantiere.
// atteso = quanto deve arrivare davvero: senza ritenuta, senza IVA con lo split payment, meno le note di credito collegate.
// Prima contano gli incassi abbinati alla fattura; il resto dei pagamenti del cantiere copre le fatture dalla più vecchia.
// I contanti non coprono le fatture da soli: se è il caso si spunta "Incassata".
export function statoFatture(vendite, pagamenti) {
  const lista = (vendite || []).slice().sort(ordine);
  const perId = {}, attesi = {};
  lista.forEach(v => { if (!eNota(v)) attesi[v.id] = Math.abs(Number(v.netto) || 0); });
  lista.filter(eNota).forEach(nc => {
    (nc.fattureCollegate || []).forEach(c => {
      const f = lista.find(x => !eNota(x) && String(x.numero) === String(c.numero) && (!c.data || x.data === c.data));
      if (f) attesi[f.id] = Math.max(0, attesi[f.id] - Math.abs(Number(nc.netto) || 0));
    });
  });
  const cantieri = {};
  const scheda = cid => (cantieri[cid] = cantieri[cid] || { cantiereId: cid, imponibile: 0, totale: 0, atteso: 0, incassato: 0, contanti: 0, daIncassare: 0, eccedenza: 0, n: 0 });
  lista.forEach(v => {
    const notaSola = eNota(v);
    const lordo = Math.abs(Number(v.netto) || 0);
    const atteso = notaSola ? 0 : attesi[v.id];
    const stornata = !notaSola && lordo > 0 && atteso <= TOLL;
    const mano = !!v.incassataMano;
    const banca = notaSola ? 0 : Math.min(atteso, incassiBanca(v));
    perId[v.id] = { atteso, banca, daPagamenti: 0, mano, residuo: 0, stato: notaSola ? "nota" : stornata ? "stornata" : "aperta" };
    if (v.cantiereId) {
      const c = scheda(v.cantiereId);
      c.imponibile += Number(v.imponibile) || 0; c.totale += Number(v.totale) || 0; c.n++;
      if (!notaSola && !stornata) c.atteso += atteso;
    }
  });
  (pagamenti || []).forEach(p => {
    if (!p.cantiereId || !cantieri[p.cantiereId]) return;
    const c = cantieri[p.cantiereId];
    if (contanti(p)) c.contanti += lordoPag(p); else c.incassato += lordoPag(p);
  });
  Object.values(cantieri).forEach(c => {
    const mie = lista.filter(v => v.cantiereId === c.cantiereId && !["nota", "stornata"].includes(perId[v.id].stato));
    let resta = c.incassato;
    mie.forEach(v => { resta -= perId[v.id].banca; });
    resta = Math.max(0, resta);
    mie.forEach(v => {
      const s = perId[v.id];
      if (s.mano) return;
      const x = Math.min(resta, Math.max(0, s.atteso - s.banca));
      s.daPagamenti = x; resta -= x;
      if (resta <= TOLL) resta = 0;
    });
    c.eccedenza = resta > TOLL ? n2(resta) : 0;
  });
  lista.forEach(v => {
    const s = perId[v.id];
    if (s.stato === "nota" || s.stato === "stornata") return;
    const r = s.mano ? 0 : s.atteso - s.banca - s.daPagamenti;
    s.residuo = r <= TOLL ? 0 : n2(r);
    s.stato = s.residuo === 0 ? "incassata" : (s.atteso - s.residuo > TOLL ? "parziale" : "aperta");
    if (v.cantiereId) cantieri[v.cantiereId].daIncassare += s.residuo;
  });
  Object.values(cantieri).forEach(c => { ["imponibile", "totale", "atteso", "incassato", "contanti", "daIncassare"].forEach(k => { c[k] = n2(c[k]); }); });
  return { perId, cantieri };
}

const normC = t => String(t || "").toLowerCase().replace(/condominio|cond\.|\bvia\b/g, "").replace(/[^a-z0-9]/g, "");
// Cantiere più probabile per una fattura: { cantiereId, punti, dubbio, altri: [...] }
export function proponiCantiere(v, cantieri, vendite) {
  const chiave = v.piva || v.cf;
  const fatti = (vendite || []).filter(x => x.id !== v.id && x.cantiereId && chiave && (x.piva || x.cf) === chiave);
  const desc = String(v.descrizione || "") + " " + String(v.causale || "");
  const punti = (cantieri || []).filter(c => !/pippo/i.test(c.nome || "")).map(c => {
    const id = c._id || c.id;
    let s = Math.max(somiglia(v.cliente, c.cliente), somiglia(v.cliente, c.nome));
    if (normC(v.cliente) && normC(v.cliente) === normC(c.nome)) s = 1.5;
    if (somiglia(desc, c.nome) >= 1) s = s > 0 ? Math.max(s, 1) + 0.4 : 0.6; // il nome del cantiere è scritto nella fattura: da solo, col cliente diverso, è solo un indizio
    if (s > 0 && Math.abs((Number(c.importo) || 0) - Math.abs(Number(v.imponibile) || 0)) <= 1) s += 0.3;
    if (fatti.some(x => x.cantiereId === id)) s += 0.5;
    if (!c.completato) s += 0.02;
    return { cantiereId: id, nome: c.nome, punti: s };
  }).filter(x => x.punti >= 0.5).sort((a, b) => b.punti - a.punti);
  if (!punti.length) return { cantiereId: "", punti: 0, dubbio: false, altri: [] };
  return { cantiereId: punti[0].cantiereId, punti: punti[0].punti, dubbio: punti[0].punti < 0.9 || (punti.length > 1 && punti[0].punti - punti[1].punti < 0.25), altri: punti.slice(0, 4) };
}

// Proposte di abbinamento di un incasso della banca alle fatture di vendita (si aggiungono a quelle già calcolate)
export function aggiungiVendite(out, m, ctx, stato, fmt) {
  if (!(m.importo > 0) || !out) return out;
  const f = fmt || {};
  const importo = n2(m.importo);
  const testo = (m.controparte || "") + " " + (m.causale || "");
  const numCausale = numeroCausale(m);
  const trovate = (ctx.vendite || []).filter(v => !eNota(v) && stato.perId[v.id] && stato.perId[v.id].stato !== "stornata"
    && !(v.incassi || []).some(x => x.movimentoId === m.id) && giorniDa(v.data, m.data) >= -5)
    .map(v => {
      const s = stato.perId[v.id];
      const sim = Math.max(somiglia(m.controparte, v.cliente), somiglia(testo, v.cliente));
      const conNum = !!numCausale && String(parseInt(numCausale, 10)) === String(parseInt(v.numero, 10));
      const stessoImporto = uguale(importo, v.netto) || uguale(importo, v.totale) || (s.atteso > 0 && uguale(importo, s.atteso));
      return { v, s, sim, conNum, stessoImporto };
    })
    .filter(x => (x.conNum && (x.sim >= 0.5 || x.stessoImporto)) || (x.stessoImporto && x.sim >= 0.5))
    .filter(x => x.s.banca < x.s.atteso - TOLL)
    .sort((a, b) => (b.conNum - a.conNum) || (b.stessoImporto - a.stessoImporto) || (b.sim - a.sim));
  if (!trovate.length) return out;
  const nuovi = trovate.map((x, i) => {
    const v = x.v;
    const pag = v.cantiereId ? (ctx.pagamenti || []).find(p => p.cantiereId === v.cantiereId && !p.movimentoBanca && !contanti(p)
      && !(ctx.pagUsati && ctx.pagUsati[p.id || p._id]) && uguale(lordoPag(p), importo)) : null;
    const crea = !pag && !!v.cantiereId && x.s.daPagamenti < importo - TOLL;
    const nome = "Fattura n. " + v.numero + " " + v.cliente + (f.data ? " del " + f.data(v.data) : "");
    const abb = { tipo: "vendita", id: v.id, etichetta: nome };
    if (pag) abb.pagamentoId = pag.id || pag._id;
    if (crea) abb.creaPagamento = true;
    const motivo = [x.conNum ? "numero nella causale" : "", x.stessoImporto ? "stesso importo" : "importo diverso: incasso parziale", x.sim >= 0.5 ? "stesso cliente" : "",
      v.cantiereId ? (pag ? "pagamento già nel cantiere" : crea ? "registra anche il pagamento nel cantiere" : "già compreso nei pagamenti del cantiere") : "fattura senza cantiere"].filter(Boolean).join(", ");
    const sicura = i === 0 && x.stessoImporto && x.sim >= 0.5 && (x.conNum || trovate.length === 1);
    return { abb, testo: nome, motivo, sicura };
  });
  out.candidati = nuovi.map(({ abb, testo: t, motivo }) => ({ abb, testo: t, motivo })).concat(out.candidati || []);
  if (nuovi[0].sicura) out.sicura = { ...nuovi[0].abb, auto: true };
  out.nota = "";
  return out;
}

// INCASSI_GRUPPI_v1: numero di fattura scritto nella causale ("FATT. N. 2", "FT.N.18", "fattura num 30")
export function numeroCausale(m) {
  const t = m.causale || m.testo || "";
  const x = t.match(/\b(?:FATTURA|FATT|FT)\.?\s*(?:NUM\.?|NR\.?|N\.?)?\s*(\d+)/i);
  return x ? String(parseInt(x[1], 10)) : "";
}
// Una fattura pagata in più bonifici: stesso numero in causale, oppure stesso cliente e stesso giorno senza numero.
// Vale solo se la somma dei bonifici liberi è quello che manca alla fattura.
export function gruppiVendite(movs, ctx, stato) {
  const liberi = (movs || []).filter(m => !m.abb && m.importo > 0);
  const presi = {}, out = [];
  (ctx.vendite || []).slice().sort(ordine).forEach(v => {
    const s = stato.perId[v.id];
    if (eNota(v) || !s || s.stato === "stornata" || s.mano) return;
    const resto = s.atteso - s.banca;
    if (resto <= TOLL) return;
    const validi = liberi.filter(m => !presi[m.id] && giorniDa(v.data, m.data) >= -5);
    let gruppo = validi.filter(m => numeroCausale(m) === String(parseInt(v.numero, 10)));
    let somma = gruppo.reduce((a, m) => a + m.importo, 0);
    if (!gruppo.length || Math.abs(somma - resto) > TOLL) {
      gruppo = []; const giorni = {};
      validi.filter(m => !numeroCausale(m) && somiglia(m.controparte, v.cliente) >= 0.5).forEach(m => { (giorni[m.data] = giorni[m.data] || []).push(m); });
      Object.values(giorni).forEach(g => { if (!gruppo.length && Math.abs(g.reduce((a, m) => a + m.importo, 0) - resto) <= TOLL) gruppo = g; });
    }
    if (!gruppo.length) return;
    const crea = !!v.cantiereId && s.daPagamenti < resto - TOLL;
    gruppo.forEach(m => {
      presi[m.id] = true;
      const abb = { tipo: "vendita", id: v.id, etichetta: "Fattura n. " + v.numero + " " + v.cliente, auto: true };
      if (crea) abb.creaPagamento = true;
      out.push({ m, abb, daCategoria: false });
    });
  });
  return out;
}

// IVA per mese: vendite (senza split payment) contro acquisti
export function ivaPerMese(vendite, documenti, anno) {
  const mesi = Array.from({ length: 12 }, () => ({ vendite: 0, acquisti: 0 }));
  (vendite || []).forEach(v => {
    if (!String(v.data || "").startsWith(anno) || v.split) return;
    mesi[parseInt(v.data.slice(5, 7), 10) - 1].vendite += Number(v.iva) || 0;
  });
  (documenti || []).forEach(d => {
    if (!String(d.data || "").startsWith(anno) || !/fattura|nota di credito|bolletta|parcella/i.test(d.tipo || "")) return;
    mesi[parseInt(d.data.slice(5, 7), 10) - 1].acquisti += Number(d.iva) || 0;
  });
  return mesi.map(x => ({ vendite: n2(x.vendite), acquisti: n2(x.acquisti), differenza: n2(x.vendite - x.acquisti) }));
}
